import React from 'react'

const Footer = () => {
  return (
    <>

      <div className="left">
        <p>&copy; Copyright 2024. All rights reserved. </p>
      </div>
      <div className="right">
        <a target='_blank' rel='noreferrer' href="/"><i class='bx bxl-instagram'></i></a>
        <a target='_blank' rel='noreferrer' href="https://www.linkedin.com/in/jagadish-madavalkar/"><i class='bx bxl-linkedin'></i></a>
        <a target='_blank' rel='noreferrer' href="https://github.com/jagadish-7"><i class='bx bxl-github'></i></a>
        <a target='_blank' rel='noreferrer' href="hellojagadish143@gmail.com"><i class='bx bx-envelope'></i></a>
      </div>



    </>
  )
}

export default Footer